import client from "./client";

export const listBranches = async () => (await client.get("/branches")).data;
export const createBranch = async (body) => (await client.post("/branches", body)).data;
export const updateBranch = async (id, body) => (await client.put(`/branches/${id}`, body)).data;
export const deleteBranch = (id, code) => client.delete(`/branches/${id}`, { data: { code } });
export const requestBranchDeleteCode = async (id) => (await client.post(`/branches/${id}/delete-code`)).data;
export const resolveTimezone = async (latitude, longitude) =>
  (await client.get("/branches/timezone", { params: { latitude, longitude } })).data;
export const branchRecommendations = async () => (await client.get("/branches/recommendations")).data;
export const branchHistory = async (id) => (await client.get(`/branches/${id}/history`)).data;
export const effectivePolicy = async (id) => (await client.get(`/branches/${id}/effective-policy`)).data;

export const myCompany = async () => (await client.get("/company")).data;
export const updateCompany = async (body) => (await client.put("/company", body)).data;

export const listHolidays = async () => (await client.get("/holidays")).data;
export const createHoliday = async (body) => (await client.post("/holidays", body)).data;
export const updateHoliday = async (id, body) => (await client.put(`/holidays/${id}`, body)).data;
export const deleteHoliday = (id) => client.delete(`/holidays/${id}`);

export const uploadLogo = async (file) => {
  const data = new FormData();
  data.append("file", file);
  const res = await client.post("/files/logo", data, { headers: { "Content-Type": "multipart/form-data" } });
  return res.data;
};

export const listUsers = async (branchId, status) =>
  (await client.get("/users", { params: { ...(branchId ? { branch_id: branchId } : {}), ...(status ? { status } : {}) } }))
    .data;
export const updateUser = async (id, body) => (await client.put(`/users/${id}`, body)).data;
export const deleteUser = (id) => client.delete(`/users/${id}`);
export const transferOwnership = async (newOwnerId) =>
  (await client.post(`/users/${newOwnerId}/transfer-ownership`)).data;
export const enrollFace = async (id, image) => (await client.post(`/users/${id}/enroll-face`, { image })).data;
export const userHistory = async (id) => (await client.get(`/users/${id}/history`)).data;
export const listBranchEmployees = async (branchId) =>
  (await client.get("/users", { params: { branch_id: branchId, status: "active" } })).data;
